import { useNavigate } from "react-router-dom";
import { ArrowRight, Sun, Feather, Heart, Eye } from "lucide-react";
import LSWLogo from "@/components/LSWLogo";
import ScintillaCard from "@/components/ScintillaCard";

const QUICK_CARDS = [
  { to: "/pratiche",  title: "Pratiche Gratuite", subtitle: "Video guidati",       accent: "#e07818", Icon: Sun,     testid: "home-card-pratiche" },
  { to: "/viaggi",    title: "Viaggi P.O.T.",     subtitle: "Percorsi onirici",     accent: "#2e9020", Icon: Feather, testid: "home-card-viaggi" },
  { to: "/community", title: "Community",          subtitle: "Unisciti a noi",       accent: "#941a7c", Icon: Heart,   testid: "home-card-community" },
  { to: "/chi-siamo", title: "Chi Siamo",          subtitle: "La nostra missione",   accent: "#1535a0", Icon: Eye,     testid: "home-card-chi-siamo" },
];

export default function Home() {
  const navigate = useNavigate();
  return (
    <div data-testid="home-screen">
      {/* Hero section with gradient background */}
      <section className="lsw-hero-gradient px-6 pt-10 pb-10 rounded-b-[32px]">
        <div className="flex justify-center mb-8">
          <LSWLogo size={80} layout="horizontal" />
        </div>

        <h1
          data-testid="home-title"
          className="font-serif-display font-light text-[40px] leading-[1.05] tracking-tight text-[#2e2820]"
        >
          Benvenuto nel tuo<br/>
          <span className="italic text-[#e07818] font-normal">spazio di trasformazione</span>
        </h1>
        <p className="font-body font-light text-base text-[#7a6f65] leading-relaxed mt-5">
          Pratiche sciamaniche, meditazioni guidate e viaggi interiori per la tua
          crescita spirituale.
        </p>

        <button
          data-testid="home-cta-start"
          onClick={() => navigate("/pratiche")}
          className="mt-7 w-full bg-[#2e2820] text-[#f9f5ef] rounded-full py-4 font-body font-medium text-base tracking-wide transition-all hover:bg-[#1a1612] active:scale-[0.98] flex items-center justify-center gap-3"
        >
          Inizia la tua pratica
          <ArrowRight strokeWidth={1.5} className="w-5 h-5" />
        </button>
      </section>

      {/* 2x2 quick access grid */}
      <section className="px-6 mt-8 grid grid-cols-2 gap-4" data-testid="home-quick-grid">
        {QUICK_CARDS.map(({ to, title, subtitle, accent, Icon, testid }) => (
          <button
            key={to}
            data-testid={testid}
            onClick={() => navigate(to)}
            className="text-left bg-[#f9f5ef] rounded-[18px] p-4 border border-[#ede7df] shadow-[0_6px_18px_-10px_rgba(46,40,32,0.18)] transition-all hover:-translate-y-1 hover:shadow-[0_12px_24px_-12px_rgba(46,40,32,0.3)] active:scale-[0.98]"
            style={{ borderTop: `2px solid ${accent}` }}
          >
            <div
              className="w-10 h-10 rounded-full flex items-center justify-center mb-3"
              style={{ background: `${accent}1a` }}
            >
              <Icon strokeWidth={1.5} className="w-5 h-5" style={{ color: accent }} />
            </div>
            <div className="font-serif-display font-medium text-xl leading-tight text-[#2e2820]">{title}</div>
            <div className="font-body font-light text-xs text-[#7a6f65] mt-1 tracking-wide">{subtitle}</div>
          </button>
        ))}
      </section>

      {/* Scintilla del Giorno */}
      <section className="px-6 mt-10">
        <ScintillaCard />
      </section>

      {/* Quote */}
      <section className="px-6 mt-12 mb-6" data-testid="home-quote">
        <div className="border-t border-[#ede7df] pt-6">
          <p className="font-serif-display font-light italic text-[22px] leading-[1.35] text-[#2e2820]">
            “Il cammino sciamanico è un ritorno a te stesso. Ogni passo verso
            l&apos;interno è un passo verso la guarigione.”
          </p>
          <p className="font-body font-light text-[11px] tracking-[0.3em] uppercase text-[#7a6f65] mt-4">
            — Love Shaman Way
          </p>
        </div>
      </section>
    </div>
  );
}
